import actions from '../../actionTypes';

export default (file, siteId) => {
  return {
    type: actions.BULK_UPLOAD,
    file,
    siteId
  };
};



// WEBPACK FOOTER //
// ./src/reducers/tags/actions/bulkUpload.js